import React, { useRef, useState } from "react";
import { api, resolveImg } from "@/lib/api";
import { Upload, Loader2, ImageIcon } from "lucide-react";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, testid = "image-upload", aspect = "aspect-video" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Selecione um arquivo de imagem válido.");
      return;
    }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Imagem enviada com sucesso.");
    } catch (e) {
      toast.error("Falha ao enviar imagem.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-3">
      <div
        className={`relative ${aspect} w-full overflow-hidden rounded-md border border-dashed border-stone-300 bg-stone-100`}
      >
        {value ? (
          <img src={resolveImg(value)} alt="preview" className="h-full w-full object-cover" />
        ) : (
          <div className="h-full w-full grid place-items-center text-stone-400">
            <ImageIcon className="h-8 w-8" />
          </div>
        )}
        {uploading && (
          <div className="absolute inset-0 grid place-items-center bg-white/70">
            <Loader2 className="h-6 w-6 animate-spin text-stone-700" />
          </div>
        )}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          data-testid={`${testid}-btn`}
          onClick={() => inputRef.current?.click()}
          className="inline-flex items-center gap-2 rounded-md bg-stone-950 text-stone-50 px-4 py-2 text-sm font-medium hover:bg-stone-800 transition-colors duration-300 disabled:opacity-50"
          disabled={uploading}
        >
          <Upload className="h-4 w-4" /> Enviar imagem
        </button>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="hidden"
          data-testid={`${testid}-input`}
          onChange={(e) => handleFile(e.target.files?.[0])}
        />
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="ou cole uma URL"
          data-testid={`${testid}-url`}
          className="flex-1 min-w-[180px] rounded-md border border-stone-300 px-3 py-2 text-sm text-stone-800 focus:outline-none focus:ring-2 focus:ring-stone-950"
        />
      </div>
    </div>
  );
}
